import {
  Component,
  EventEmitter,
  Injector,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ImpersonationService } from '@app/admin/users/impersonation.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'deleteStaffModal',
  templateUrl: './delete-staff-modal.component.html',
  styleUrls: ['delete-staff-modal.component.less'],
})
export class DeleteStaffModalComponent extends AppComponentBase {
  @ViewChild('modal', { static: true }) modal: ModalDirective;

  options: any;

  @Input()
  warningMessage: string =""
  @Input()
  type: string =""
  @Input()
  warningMessage2: string =""
  @Input()
  warningMessage2Time: string =""
  @Input()
  warningMessage2TimeUnit: string =""
  @Input()
  Button1Text: string =""
  @Input()
  Button2Text: string =""
  
  @Output() deleteStaff$: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    injector: Injector,
    private _impersonationService: ImpersonationService
  ) {
    super(injector);
  }

  show(options: any): void {
    this.options = options;
    this.modal.show();
  }
  close(): void {
    this.modal.hide();
  }

  delete(): void {
    this.deleteStaff$.emit(this.options);
    this.modal.hide();
  }
}
